import React, { Component } from 'react'
import './styles.scss'
import { Button } from 'primereact/button';
import { TickBgIcon } from '../svgIcons';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { BasicLazyParams } from '../../utile';
import { Dialog } from 'primereact/dialog';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import { RadioButton } from 'primereact/radiobutton';
import { baseUrlAdmin } from '../../store/apiConstants';
import Service from '../../services';
import ClassetTextArea from '../../classetComponents/classetTextArea';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../loadingComponent';
import { debounce } from 'lodash';
import ClassetStudentSearchFilter from '../Search/ClassetStudentSearchFilter';
import BranchToSectionDD from '../BaseDropdownComponents/BranchToSectionDD';
import ClassetInputText from '../../classetComponents/classetInputText';
import ClassetCalendar from '../../classetComponents/classetCalender';
import { paymentModes } from '../../constants';
import { parseUnAssignFeeURL } from '../../utils/unAssignFeeNavigation';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';

const searchTypeOptions = [
    { label: "Student Name", value: "studentName" },
    { label: "Enrollment Number", value: "enrollmentNumber" }
]

export class UnAssignFee extends Component {
    constructor(props) {
        super(props)

        this.studentSearchRef = React.createRef();
        this.state = {
            lazyParams: BasicLazyParams,
            openUnAssignDialog: false,
            searchLevel: 1,
            searchValue: "",
            students: [],
            searchType: searchTypeOptions[0].value,
            studentId: '',
            data: [],
            unAssignInfo: {},
            unassignOption: '', // 'refund', 'advance', 'adjust'
            unassignAmount: '',
            feeInstallments: [],
            installmentAmounts: [], // Changed to array
            isLoadingInstallments: false,
            // Bank information for refund option
            showParentDetailsDialog: false,
            paymentType: '',
            transactionDate: null,
            chequeIssuedTo: '',
            chequeNo: '',
            chequeDate: null,
            bankName: '',
            bankBranchName: '',
            transactionId: '',
            approvalCode: '',
            cardNo: '',
            userBankName: '',
            bankAccountHolderName: '',
            accountNumber: '',
            ifscCode: '',
            bankNameAndBranch: '',
            rrNumber: '',
            upiId: ''
        }
        this.debouncedApiCall = debounce(this.getData, 500)
        this.service = new Service()
    }

    componentDidMount() {
        // create a ref to the student search filter if not already present
        if (!this.studentSearchRef) {
            this.studentSearchRef = React.createRef();
        }

        // Parse incoming URL params for UnAssignFee and initialize state accordingly
        try {
            const urlParams = parseUnAssignFeeURL(window.location.search);

            if (urlParams?.orgId) {
                // ensure org context is set so downstream calls use correct org
                localStorage.setItem('selectedOrgId', urlParams.orgId);
            }

            const studentId = urlParams?.studentId || '';
            const searchLevel = parseInt(urlParams?.searchLevel) || 2;

            if (studentId && this.props.students && this.props.students.length > 0) {
                // Filter student from Redux store based on studentId
                const selectedStudent = this.props.students.find(
                    student => student.user_id === studentId
                );

                if (selectedStudent) {
                    // Extract student info and convert to arrays
                    const studentInfo = selectedStudent.user_info || {};
                    
                    // Helper to ensure array format
                    const toArray = (value) => value ? [value] : [];

                    // Set the state and dropdown values with data from Redux store
                    this.setState({
                        searchLevel,
                        studentId
                    }, () => {
                        // Set dropdown values with all required IDs as arrays
                        this.setDropdownValues({
                            studentIds: [studentId],
                            students: [selectedStudent],
                            boardId: toArray(selectedStudent.boardId || studentInfo.boardId),
                            branchId: toArray(selectedStudent.branchId || studentInfo.branchId),
                            classId: toArray(selectedStudent.classId || studentInfo.classId),
                            sectionId: toArray(selectedStudent.sectionId || studentInfo.sectionId),
                            selectedBoardName: selectedStudent.boardName || studentInfo["custom:board"] || '',
                            selectedbranchName: selectedStudent.branchName || studentInfo.branchName || '',
                            selectedClassName: selectedStudent.gradeName || studentInfo["custom:grade"] || '',
                            selectedsectionName: selectedStudent.sectionName || studentInfo.sectionName || ''
                        });
                    });
                } else {
                    // If student not found in store, just set studentIds to trigger ClassetStudentSearchFilter
                    this.setState({
                        searchLevel,
                        studentId
                    }, () => {
                        this.setDropdownValues({ studentIds: [studentId] });
                    });
                }
            } else if (studentId) {
                // Fallback: students not loaded yet, just set studentIds
                this.setState({
                    searchLevel,
                    studentId
                }, () => {
                    this.setDropdownValues({ studentIds: [studentId] });
                });
            }
        } catch (e) {
            // parsing shouldn't break the page; log for debugging
            console.error('Error parsing UnAssignFee URL params', e);
        }

        // No manual popstate handling here; rely on browser back to restore the previous URL
        // and let StudentProfile react to query params (it listens for window.location.search changes).
    }

    // componentWillUnmount: no cleanup required for popstate (none registered)

    onHandleUnassign = (rowdata) => {
        // console.log(rowdata,"unassign")
        // If amountPaid is 0, default to 'noAdjustments' option and disable it
        const defaultOption = rowdata?.amountPaid === 0 ? 'noAdjustments' : '';

        this.setState({
            openUnAssignDialog: true,
            unAssignInfo: rowdata,
            unassignOption: defaultOption
        });
    }

    onHandleCancelUnAssign = () => {
        this.setState({
            openUnAssignDialog: false,
            unAssignInfo: {},
            unassignOption: '',
            unassignAmount: '',
            feeInstallments: [],
            installmentAmounts: [], // Reset installment amounts
            remarks: '',
            showParentDetailsDialog: false,
            paymentType: '',
            transactionDate: null,
            chequeIssuedTo: '',
            chequeNo: '',
            chequeDate: null,
            bankName: '',
            bankBranchName: '',
            transactionId: '',
            approvalCode: '',
            cardNo: '',
            userBankName: '',
            bankAccountHolderName: '',
            accountNumber: '',
            ifscCode: '',
            bankNameAndBranch: '',
            rrNumber: '',
            upiId: ''
        })
    }

    onHandleNext = () => {
        // For refund option, show parent details dialog
        if (this.state.unassignOption === 'refund') {
            if (!this.validateAmounts()) {
                return;
            }
            this.setState({
                showParentDetailsDialog: true,
                openUnAssignDialog: false
            });
        } else {
            // For other options, proceed with normal unassign
            this.handleUnassign();
        }
    }

    onHandleParentDetailsClose = () => {
        this.setState({
            showParentDetailsDialog: false,
            openUnAssignDialog: true,
            paymentType: '',
            chequeIssuedTo: '',
            chequeNo: '',
            chequeDate: null,
            bankName: '',
            bankBranchName: '',
            transactionId: '',
            approvalCode: '',
            cardNo: '',
            userBankName: '',
            bankAccountHolderName: '',
            accountNumber: '',
            ifscCode: '',
            bankNameAndBranch: '',
            rrNumber: '',
            upiId: ''
        });
    }
    getStudents = () => {
        this.setState({ isLoading: true })
        let academicYear = localStorage.getItem('userAcademicYear')
        let url = `${baseUrlAdmin}/fine/student?status=Active`; // Add status filter
        let payload = {
            "branchId": this.state.dropdownsData?.branchId,
            "boardId": this.state.dropdownsData?.boardId,
            "classId": this.state.dropdownsData?.classId,
            "sectionId": this.state.dropdownsData?.sectionId,
            "academicYear": academicYear,
            status: 'Active' // Add to payload as well
        }
        this.service.post(url, payload, true).then(data => {
            const studentsData = data?.res?.data.map(each => {
                return {
                    label: each?.name,
                    value: each?.user_id
                }
            })

            if (data?.status) {
                this.setState({
                    students: studentsData,
                    isLoading: false
                })

            } else {
                this.setState({ isLoading: false })
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: data.errMessage, life: 3000 });
            }

        }).catch(error => {
            this.setState({ isLoading: false })
            this.toast.show({ severity: 'error', summary: 'Some error occured', detail: 'Error Occured', life: 3000 });

        })

    }
    handleSearchLevel = (value) => {
        this.setState({ searchLevel: value }
        )
    }

    // setDropdownValues = (dropdownsData) => {
    //     console.log(dropdownsData, "dropdownsData")
    //     this.setState({
    //         dropdownsData,
    //         data: [],
    //         studentId: ''
    //     }, () => { this.getStudents() })
    // }
    setDropdownValues = (dropdownsData) => {

        // Update the visual selection in the search filter if ref exists
        // Use multiple retries with increasing delays to ensure the ref is mounted and students are loaded
        if (dropdownsData?.studentIds) {
            const updateSearchFilter = (retryCount = 0) => {
                if (this.studentSearchRef?.current?.setSelectedStudents) {
                    console.log('UnAssignFee: Calling setSelectedStudents with', dropdownsData.studentIds);
                    this.studentSearchRef.current.setSelectedStudents(dropdownsData.studentIds);
                } else if (retryCount < 20) { // Retry for up to 2 seconds
                    console.log('UnAssignFee: Ref not ready, retrying...', retryCount);
                    setTimeout(() => updateSearchFilter(retryCount + 1), 100);
                } else {
                    console.warn('UnAssignFee: Failed to update search filter - ref not available');
                }
            };
            
            updateSearchFilter();
        }

        this.setState({
            dropdownsData,
            data: [],
            studentId: dropdownsData?.studentIds?.[0] || '' // Set first studentId if exists
        }, () => {
            if (dropdownsData?.studentIds?.length > 0) {
                // If studentIds exists, call getData directly
                this.getData();
            } else {
                // Otherwise call getStudents as before
                this.getStudents();
            }
        });
    }

    handleSetSearchTypeValue = (value) => {
        this.setState({ searchType: value }, () => {
            if (this.state.searchType == "studentName") {
                this.setState({ isUserNameSearch: true, })
            } else {
                this.setState({ isUserEnrollSearch: true, })
            }

        })
    }

    handleSetSearchValue = (value) => {
        this.setState({
            searchValue: value,
            dropdownsData: {
                boardId: '',
                branchId: "",
                classId: '',
                sectionId: '',
            }
        }, () => {
            this.debouncedApiCall()

        })
    }
    onStudentChange = (e) => {
        this.setState({ studentId: e.value, data: [], totalRecords: 0 }, () => {
            this.getData()
        })

    }

    getData = () => {
        this.setState({
            isLoading: true, data: [],
            totalRecords: 0,
        })
        let academicYear = localStorage.getItem('userAcademicYear')
        let { lazyParams } = this.state;
        let url = `${baseUrlAdmin}/fee-unassign/fee-types?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=`
        let username = this.state.searchType === 'studentName' ? this.state?.searchValue : ""
        let enrollmentNo = this.state.searchType === 'enrollmentNumber' ? this.state?.searchValue : ""

        let payload = {
            "branchId": this.state?.dropdownsData?.branchId,
            "boardId": this.state?.dropdownsData?.boardId,
            "classId": this.state?.dropdownsData?.classId,
            "sectionId": this.state?.dropdownsData?.sectionId,
            "studentId": this.state?.studentId,
            "academicYear": academicYear,
            "username": username,
            "enrollmentNo": enrollmentNo


        }
        this.service?.post(url, payload, true).then(data => {
            if (data?.status && data?.res?.data?.length) {
                // const totalStudentDue=
                this.setState({
                    data: data?.res?.data || [],
                    isLoading: false,
                    totalRecords: data?.res?.totalRecords || 0,

                })

            } else if (data?.status && !data?.res?.data?.length) {
                this.setState({ isLoading: false })
                this.toast.show({ severity: 'success', summary: 'Success', detail: 'No records found', life: 3000 });
            } else {
                this.setState({ isLoading: false })
                this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: 'Error occurred', life: 3000 });
            }

        }).catch(error => {
            this.setState({ isLoading: false })
            this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: 'Error occurred', life: 3000 });

        })

    }
    onPage = (event) => {
        this.setState((prevState) => {
            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            }
        }, this.getData)
    }

    handleUnassign = () => {
        // Always validate (for all cases)
        if (!this.validateAmounts()) {
            return;
        }

        // If it's a refund option and we're in the parent details dialog, validate payment mode
        if (this.state.unassignOption === 'refund' && this.state.showParentDetailsDialog) {
            if (!this.validatePaymentMode()) {
                return;
            }
        }

        let academicYear = localStorage.getItem('userAcademicYear')
        
        // Helper function to ensure values are arrays
        const ensureArray = (value) => {
            if (!value) return [];
            if (Array.isArray(value)) return value;
            return [value];
        };
        
        // Safely get student info - check if students array exists and has elements
        const studentInfo = this.state?.dropdownsData?.students?.[0]?.user_info || {};
        
        // Extract IDs as arrays from dropdownsData, fallback to studentInfo
        const boardId = this.state?.dropdownsData?.boardId?.length 
            ? ensureArray(this.state.dropdownsData.boardId)
            : ensureArray(studentInfo.boardId);
        
        const branchId = this.state?.dropdownsData?.branchId?.length 
            ? ensureArray(this.state.dropdownsData.branchId)
            : ensureArray(studentInfo.branchId);
        
        const gradeId = this.state?.dropdownsData?.classId?.length 
            ? ensureArray(this.state.dropdownsData.classId)
            : ensureArray(studentInfo.classId);
        
        const sectionId = this.state?.dropdownsData?.sectionId?.length 
            ? ensureArray(this.state.dropdownsData.sectionId)
            : ensureArray(studentInfo.sectionId);
        
        let payload = {
            ...this.state.unAssignInfo,
            user_id: this.state.studentId,
            academicYear: academicYear,
            remarks: this.state.remarks,
            isAssigned: false,
            boardId: boardId,
            branchId: branchId,
            gradeId: gradeId,
            sectionId: sectionId,
            boardName: this.state?.dropdownsData?.selectedBoardName ?? studentInfo?.["custom:board"],
            className: this.state?.dropdownsData?.selectedClassName ?? studentInfo?.["custom:grade"],
            branchName: this.state?.dropdownsData?.selectedbranchName ?? studentInfo.branchName,
            sectionName: this.state?.dropdownsData?.selectedsectionName ?? studentInfo.sectionName,
        }

        // Add new fields based on amountPaid and unassign option
        if (this.state.unAssignInfo.amountPaid > 0) {
            payload.unassignOption = this.state.unassignOption;

            if (this.state.unassignOption === 'refund') {
                payload.unassignAmount = this.state.unassignAmount;
                // Add parent bank information for refund option
                payload.parentBankInfo = {
                    paymentType: this.state.paymentType,
                    chequeIssuedTo: this.state.chequeIssuedTo,
                    chequeNo: this.state.chequeNo,
                    chequeDate: this.state.chequeDate,
                    bankName: this.state.bankName,
                    bankBranchName: this.state.bankBranchName,
                    accountNo: this.state.accountNo,
                    accountHolderName: this.state.accountHolderName,
                    ifscCode: this.state.ifscCode,
                    rrNumber: this.state.rrNumber,
                    upiId: this.state.upiId
                };
            } else if (this.state.unassignOption === 'advance') {
                payload.unassignAmount = this.state.unassignAmount;
            } else if (this.state.unassignOption === 'adjust') {
                payload.installmentAmounts = this.state.installmentAmounts;
            }
        }

        this.setState({ isLoading: true })
        let url = `${baseUrlAdmin}/fee-unassign/add-unassign`
        this.service.post(url, payload, true).then((data) => {
            if (data.status) {
                this.setState({
                    isLoading: false,
                    openUnAssignDialog: false,
                    showParentDetailsDialog: false,
                    remarks: '',
                    unassignOption: '',
                    unassignAmount: '',
                    installmentAmounts: [],
                    // Reset parent bank info
                    paymentType: '',
                    chequeIssuedTo: '',
                    chequeNo: '',
                    chequeDate: null,
                    bankName: '',
                    bankBranchName: '',
                    accountNo: '',
                    accountHolderName: '',
                    ifscCode: '',
                    rrNumber: '',
                    upiId: ''
                }, () => this.getData())
                this.toast?.show({ severity: 'success', summary: 'Success', detail: data?.res?.message, life: 3000 });

            }
            else {
                this.setState({ isLoading: false })
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: 'Error Occured', life: 3000 });
            }

        }).catch(error => {
            this.setState({ isLoading: false })
            this.toast.show({ severity: 'error', summary: 'Some error occured', detail: 'Error Occured', life: 3000 });

        })
    }

    // Method to fetch fee installments for adjustment option
    getFeeInstallments = () => {
        if (!this.state.studentId) {
            return;
        }

        this.setState({ isLoadingInstallments: true });
        let academicYear = localStorage.getItem('userAcademicYear');
        let payload = {
            branchId: this.state?.dropdownsData?.branchId,
            boardId: this.state?.dropdownsData?.boardId,
            classId: this.state?.dropdownsData?.classId,
            sectionId: this.state?.dropdownsData?.sectionId,
            studentId: this.state?.studentId,
            academicYear: academicYear,
            excludeFeeType: this.state.unAssignInfo?.feeType // Exclude current fee type being unassigned
        };

        let url = `${baseUrlAdmin}/concession/get-feetype-terms/${this.state.studentId}?academicYear=${academicYear}`;
        this.service.get(url, true).then(data => {
            if (data?.status && data?.res?.data?.agg?.length) {
                // Filter out installments that have zero due amount
                const availableInstallments = data.res.data?.agg.filter(installment =>
                    installment?.feeTypeId !== this.state.unAssignInfo.feeTypeId
                );

                this.setState({
                    feeInstallments: availableInstallments,
                    isLoadingInstallments: false,
                    installmentAmounts: [] // Reset installment amounts
                });
            } else {
                this.setState({
                    feeInstallments: [],
                    isLoadingInstallments: false
                });
                if (!data?.status) {
                    this.toast.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to fetch fee installments',
                        life: 3000
                    });
                }
            }
        }).catch(error => {
            this.setState({
                feeInstallments: [],
                isLoadingInstallments: false
            });
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error fetching fee installments',
                life: 3000
            });
        });
    }

    // Event handlers for the new functionality
    handleUnassignOptionChange = (option) => {
        this.setState({
            unassignOption: option,
            unassignAmount: '',
            installmentAmounts: []
        }, () => {
            // If adjust option is selected, fetch fee installments
            if (option === 'adjust') {
                this.getFeeInstallments();
            }
        });
    }

    handleUnassignAmountChange = (value) => {
        const maxAmount = this.state.unAssignInfo?.amountPaid || 0;
        if (value <= maxAmount) {
            this.setState({ unassignAmount: value });
        } else {
            this.toast.show({
                severity: 'warn',
                summary: 'Invalid Amount',
                detail: `Amount cannot exceed ₹${maxAmount}`,
                life: 3000
            });
        }
    }

    handleInstallmentAmountChange = (installment, value, individualDueAmount) => {
        const { installmentAmounts, unAssignInfo } = this.state;
        const maxAmount = unAssignInfo?.amountPaid || 0;

        // First check if the value exceeds the individual installment's due amount
        if (value > individualDueAmount) {
            this.toast.show({
                severity: 'warn',
                summary: 'Invalid Amount',
                detail: `Amount cannot exceed installment due amount of ₹${individualDueAmount.toFixed(2)}`,
                life: 3000
            });
            return;
        }

        // Calculate current total of all installment amounts
        const otherAmounts = installmentAmounts
            .filter(item => item._id !== installment._id)
            .reduce((sum, item) => sum + (item.requestedAmount || 0), 0);

        const newTotal = otherAmounts + (value || 0);

        if (newTotal <= maxAmount) {
            // Remove existing entry for this installment if it exists
            const updatedAmounts = installmentAmounts.filter(item => item._id !== installment._id);

            // Add new entry if value is greater than 0
            if (value > 0) {
                updatedAmounts.push({
                    ...installment,
                    requestedAmount: value
                });
            }

            this.setState({
                installmentAmounts: updatedAmounts
            });
        } else {
            this.toast.show({
                severity: 'warn',
                summary: 'Invalid Amount',
                detail: `Total amount cannot exceed ₹${maxAmount}`,
                life: 3000
            });
        }
    }

    // Validation methods
    validatePaymentMode = () => {
        const { paymentType, accountHolderName, accountNo, ifscCode, bankName, upiId, chequeIssuedTo, chequeNo, chequeDate, bankBranchName, rrNumber } = this.state;

        // Payment Mode is mandatory
        if (!paymentType) {
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Payment Mode is mandatory',
                life: 3000
            });
            return false;
        }

        // Online payment validation
        if (paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54') {
            if (!accountHolderName || accountHolderName.trim() === '') {
                this.toast.show({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: 'Account Holder Name is mandatory for online payment',
                    life: 3000
                });
                return false;
            }
            if (!accountNo || accountNo.trim() === '') {
                this.toast.show({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: 'Account Number is mandatory for online payment',
                    life: 3000
                });
                return false;
            }
            if (!ifscCode || ifscCode.trim() === '') {
                this.toast.show({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: 'IFSC Code is mandatory for online payment',
                    life: 3000
                });
                return false;
            }
            if (!bankName || bankName.trim() === '') {
                this.toast.show({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: 'Bank Name & Branch is mandatory for online payment',
                    life: 3000
                });
                return false;
            }
        }

        // QR Code/UPI payment validation
        if (paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489') {
            if (!upiId || upiId.trim() === '') {
                this.toast.show({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: 'UPI ID is mandatory for QR Code payment',
                    life: 3000
                });
                return false;
            }
        }

        // Cheque payment validation
        if (paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f') {
            // Cheque fields are optional based on the current implementation
            // But you can add validation if needed
        }

        // DD payment validation
        if (paymentType === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1') {
            // DD fields are optional based on the current implementation
            // But you can add validation if needed
        }

        return true;
    }

    validateAmounts = () => {
        const { unassignOption, unassignAmount, installmentAmounts, unAssignInfo, remarks } = this.state;
        const maxAmount = unAssignInfo?.amountPaid || 0;

        // Check if action is selected (only required when amountPaid > 0)
        if (unAssignInfo?.amountPaid > 0 && !unassignOption) {
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Please select at least one action',
                life: 3000
            });
            return false;
        }

        // Check if remarks are mandatory
        if (!remarks || remarks.trim() === '') {
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Remarks are mandatory',
                life: 3000
            });
            return false;
        }

        if (unassignOption === 'refund' || unassignOption === 'advance') {
            if (unassignAmount < 0) {
                this.toast.show({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: 'Please enter a valid amount',
                    life: 3000
                });
                return false;
            }
            if (unassignAmount > maxAmount) {
                this.toast.show({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: `Amount cannot exceed ₹${maxAmount}`,
                    life: 3000
                });
                return false;
            }
        }

        if (unassignOption === 'adjust') {
            const totalInstallmentAmount = installmentAmounts
                .reduce((sum, item) => sum + (item.requestedAmount || 0), 0);

            if (totalInstallmentAmount <= 0) {
                this.toast.show({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: 'Please enter amounts for at least one installment',
                    life: 3000
                });
                return false;
            }

            if (totalInstallmentAmount > maxAmount) {
                this.toast.show({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: `Total amount cannot exceed ₹${maxAmount}`,
                    life: 3000
                });
                return false;
            }
        }

        // No additional validation needed for "noAdjustments" option

        return true;
    }


    render() {
        return (
            <div className="m-2">
                <div className=" datatable-crud-demo ma-m30 mx-2 mb-5">


                    {/* <div style={{ marginLeft: "100px" }} className="flex justify-content-start align-items-center">
                        <span className="">OR</span>
                    </div> */}
                    <div className="flex">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton inputId="ingredient1" onChange={(e) => this.handleSearchLevel(1)} checked={this.state.searchLevel === 1} />
                        </div>

                      
                        <div>
                            <BranchToSectionDD selectedValue={this.state.searchLevel} setValues={this.setDropdownValues} />
                        </div>


                    </div>
                    <div className="col-12 ml-5">
                        <label className='label' style={{ fontFamily: 'InterSemiBold', fontWeight: 500, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>Student<span className='ma-required'>*</span></label>
                        {/* <div className="flex"> */}
                        <div className='mt-2 flex'>
                            <ClassetDropdown
                                // icon={<MailIcon />}
                                id='paymentMode'
                                className=""
                                height="48px"
                                width="327px"
                                options={this.state?.students}
                                value={this.state.studentId}
                                disabled={this.state?.searchLevel === 2}
                                onChange={this.onStudentChange}
                                placeholder={(
                                    <div>
                                        <span className=''>Select Student</span>
                                    </div>
                                )}
                            />
                            {this.state.isLoading && <LoadingComponent />}

                        </div>
                        {/* </div> */}
                    </div>
                    <div className="flex mt-4">
                        <div className="flex flex-column justify-content-center align-items-center -mt-3">
                            <RadioButton inputId="ingredient2" onChange={(e) => this.handleSearchLevel(2)} checked={this.state.searchLevel === 2} />
                        </div>

                        <div className="field ml-4">
                            {/* <ClassetStudentSearch selectedValue={this.state.searchLevel} handleTypeValue={this.handleSetSearchTypeValue} handleSearchValue={this.handleSetSearchValue} /> */}
                            <ClassetStudentSearchFilter
                                ref={this.studentSearchRef}
                                selectedValue={this.state.searchLevel}
                                setValues={this.setDropdownValues}
                                singleSelectInput={true}

                            />

                        </div>
                    </div>
                </div>

                <DataTable ref={(el) => this.dt = el}
                    // value={this.state.feeTypeData}   
                    value={this.state.data}
                    dataKey="id"
                    paginator
                    lazy
                    responsiveLayout="scroll"
                    className="dataTableValuesText"
                    showGridlines
                    selectionMode={'checkbox'}
                    columnResizeMode="expand"
                    resizableColumns
                    onPage={this.onPage}
                    first={this.state.lazyParams.first}
                    last={this.state.totalRecords}
                    rows={this.state.lazyParams.rows}
                    totalRecords={this.state.totalRecords}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    globalFilter={this.state.globalFilter}
                >

                    <Column filterField="" field="feeType" sortable bodyClassName='text-center' header="Fee Type" alignHeader={"center"} />
                    <Column filterField="" field="totalAmount" sortable bodyClassName='text-center' header="Total Fee" alignHeader={"center"} />
                    <Column filterField="" field="concession" sortable bodyClassName='text-center' header="Concession" alignHeader={"center"} body={(rowData) => Math.round(rowData.concession * 100) / 100} />
                    <Column filterField="" field="fineAmt" sortable bodyClassName='text-center' header="Fine Amount" alignHeader={"center"} body={(rowData) => Math.round(rowData.fineAmt * 100) / 100} />
                    <Column filterField="" field="dueAmount" sortable bodyClassName='text-center' header="Total Due" alignHeader={"center"} body={(rowData) => Math.round(rowData.dueAmount * 100) / 100} />
                    <Column filterField="" field="amountPaid" sortable bodyClassName='text-center' header="Paid Fee" alignHeader={"center"} body={(rowData) => Math.round(rowData.amountPaid * 100) / 100} />
                    <Column sortable bodyClassName='text-center' header="Action" alignHeader={"center"} body={(rowData) => {
                        return (
                            <div className=''>
                                {rowData.isUnassignApprovalRaised ? (
                                    <Button
                                        disabled={true}
                                        style={{ backgroundColor: '#FFA500', borderRadius: '12px', cursor: 'not-allowed', border: 'none' }}
                                    >
                                        <p className='payBtn'>Pending</p>
                                    </Button>
                                ) : (
                                    <Button
                                        onClick={(e) => this.onHandleUnassign(rowData)}
                                        style={{ backgroundColor: '#076EFF', borderRadius: '12px' }}
                                    >
                                        <p className='payBtn'>Raise UnAssign Request</p>
                                    </Button>
                                )}
                            </div>
                        )
                    }} />
                </DataTable>
                <Dialog
                    blockScroll={false}
                    visible={this.state.openUnAssignDialog}
                    draggable={false}
                    style={{
                        width: this.state.unassignOption === 'adjust' ? "80vw" : "500px",
                        minHeight: "400px"
                    }}
                    closable={true}
                    onHide={this.onHandleCancelUnAssign}
                    footer={() => {
                        return (
                            <div className='flex justify-content-center'>
                                <Button
                                    label={this.state.unassignOption === 'refund' ? "Next" : "Raise Request"}
                                    className='confirmDialogAcceptBtn mr-4  px-6'
                                    onClick={this.onHandleNext}
                                />
                                <Button style={{ color: "black" }} label="Cancel" className='confirmDialogCancelBtn px-6' onClick={this.onHandleCancelUnAssign} />
                            </div>
                        );
                    }}
                >
                    <div className='text-center mb-4'>
                        <TickBgIcon width={32} height={32} color="#268900" />
                        <h4 className="confirmDialogHeader" style={{ fontFamily: 'InterSemiBold', fontWeight: 600, fontSize: '20px', lineHeight: '24px', letterSpacing: '0.15px' }}>Confirm Unassign Fee</h4>
                        <div className="mt-3">
                            <p className="text-lg font-semibold" style={{ fontFamily: 'InterRegular', fontWeight: 500, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.5px' }}>
                                Fee Type: {this.state.unAssignInfo?.feeType}
                            </p>
                            <p className="text-lg font-semibold" style={{ fontFamily: 'InterRegular', fontWeight: 500, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.5px' }}>
                                Total Fee: ₹{this.state.unAssignInfo?.totalAmount}
                            </p>
                            <p className="text-lg font-semibold" style={{ fontFamily: 'InterRegular', fontWeight: 500, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.5px' }}>
                                Paid Amount: ₹{this.state.unAssignInfo?.amountPaid || 0}
                            </p>
                        </div>
                    </div>

                    {/* Show radio button options */}
                    <div className="mb-4">
                        <label className='label mb-3' style={{ fontFamily: 'InterSemiBold', fontWeight: 500, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                            Select Action{this.state.unAssignInfo?.amountPaid > 0 ? <span className='ma-required'>*</span> : ''}
                        </label>
                        <div className="flex flex-column gap-3">
                            {/* Show payment-related options only if amount paid > 0 */}
                            {this.state.unAssignInfo?.amountPaid > 0 && (
                                <>
                                    <div className="p-3 border-round" style={{ backgroundColor: this.state.unassignOption === 'refund' ? '#D1E4FF' : '#f8f9fa', border: this.state.unassignOption === 'refund' ? '2px solid #076EFF' : '1px solid #e9ecef', cursor: 'pointer' }} onClick={() => this.handleUnassignOptionChange('refund')}>
                                        <div className="flex align-items-center">
                                            <RadioButton
                                                inputId="refund"
                                                name="unassignOption"
                                                value="refund"
                                                onChange={(e) => this.handleUnassignOptionChange(e.value)}
                                                checked={this.state.unassignOption === 'refund'}
                                            />
                                            <label htmlFor="refund" className="ml-2 font-semibold cursor-pointer" style={{ fontFamily: 'InterSemiBold', fontWeight: 500, fontSize: '16px', lineHeight: '14px', letterSpacing: '0.5px' }}>Raise Refund</label>
                                        </div>
                                        <p className="text-sm text-600 mt-2 ml-4" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px', color: '#4E616B' }}>Process refund for the paid amount</p>
                                    </div>

                                    <div className="p-3 border-round" style={{ backgroundColor: this.state.unassignOption === 'advance' ? '#D1E4FF' : '#f8f9fa', border: this.state.unassignOption === 'advance' ? '2px solid #076EFF' : '1px solid #e9ecef', cursor: 'pointer' }} onClick={() => this.handleUnassignOptionChange('advance')}>
                                        <div className="flex align-items-center">
                                            <RadioButton
                                                inputId="advance"
                                                name="unassignOption"
                                                value="advance"
                                                onChange={(e) => this.handleUnassignOptionChange(e.value)}
                                                checked={this.state.unassignOption === 'advance'}
                                            />
                                            <label htmlFor="advance" className="ml-2 font-semibold cursor-pointer" style={{ fontFamily: 'InterSemiBold', fontWeight: 500, fontSize: '16px', lineHeight: '14px', letterSpacing: '0.5px' }}>Move to Advance</label>
                                        </div>
                                        <p className="text-sm text-600 mt-2 ml-4" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px', color: '#4E616B' }}>Transfer amount to student's advance balance</p>
                                    </div>

                                    <div className="p-3 border-round" style={{ backgroundColor: this.state.unassignOption === 'adjust' ? '#D1E4FF' : '#f8f9fa', border: this.state.unassignOption === 'adjust' ? '2px solid #076EFF' : '1px solid #e9ecef', cursor: 'pointer' }} onClick={() => this.handleUnassignOptionChange('adjust')}>
                                        <div className="flex align-items-center">
                                            <RadioButton
                                                inputId="adjust"
                                                name="unassignOption"
                                                value="adjust"
                                                onChange={(e) => this.handleUnassignOptionChange(e.value)}
                                                checked={this.state.unassignOption === 'adjust'}
                                            />
                                            <label htmlFor="adjust" className="ml-2 font-semibold cursor-pointer" style={{ fontFamily: 'InterSemiBold', fontWeight: 500, fontSize: '16px', lineHeight: '14px', letterSpacing: '0.5px' }}>Adjust for Remaining Fee Installments</label>
                                        </div>
                                        <p className="text-sm text-600 mt-2 ml-4" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px', color: '#4E616B' }}>Distribute amount to other pending fee installments</p>
                                    </div>
                                </>
                            )}

                            {/* No Adjustments option - always show, disabled when amountPaid is 0 */}
                            <div className="p-3 border-round" style={{
                                backgroundColor: this.state.unassignOption === 'noAdjustments' ? '#D1E4FF' : '#f8f9fa',
                                border: this.state.unassignOption === 'noAdjustments' ? '2px solid #076EFF' : '1px solid #e9ecef',
                                cursor: this.state.unAssignInfo?.amountPaid === 0 ? 'not-allowed' : 'pointer',
                                opacity: this.state.unAssignInfo?.amountPaid === 0 ? 0.6 : 1
                            }} onClick={() => {
                                if (this.state.unAssignInfo?.amountPaid !== 0) {
                                    this.handleUnassignOptionChange('noAdjustments');
                                }
                            }}>
                                <div className="flex align-items-center">
                                    <RadioButton
                                        inputId="noAdjustments"
                                        name="unassignOption"
                                        value="noAdjustments"
                                        onChange={(e) => {
                                            if (this.state.unAssignInfo?.amountPaid !== 0) {
                                                this.handleUnassignOptionChange(e.value);
                                            }
                                        }}
                                        checked={this.state.unassignOption === 'noAdjustments'}
                                        disabled={this.state.unAssignInfo?.amountPaid === 0}
                                    />
                                    <label htmlFor="noAdjustments" className="ml-2 font-semibold cursor-pointer" style={{ fontFamily: 'InterSemiBold', fontWeight: 500, fontSize: '16px', lineHeight: '14px', letterSpacing: '0.5px' }}>No Adjustments</label>
                                </div>
                                <p className="text-sm text-600 mt-2 ml-4" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px', color: '#4E616B' }}>Keep the amount as closing fee type amount</p>
                            </div>
                        </div>
                    </div>

                    {/* Amount input for Refund and Advance options */}
                    {(this.state.unassignOption === 'refund' || this.state.unassignOption === 'advance') && (
                        <div className="mb-4">
                            <label className='label mb-2' style={{ fontFamily: 'InterSemiBold', fontWeight: 500, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                                Amount<span className='ma-required'>*</span>
                                <span className="text-sm text-500 ml-2" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '12px', lineHeight: '18px', letterSpacing: '0.4px', color: '#667A85' }}>
                                    (Max: ₹{this.state.unAssignInfo?.amountPaid})
                                </span>
                            </label>
                            <div className="mt-2">
                                <ClassetInputText
                                    value={this.state.unassignAmount}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // Only allow numbers and decimal point
                                        if (/^\d*\.?\d*$/.test(value)) {
                                            this.handleUnassignAmountChange(parseFloat(value) || 0);
                                        }
                                    }}
                                    placeholder="Enter amount"
                                    className="w-full"
                                    height="48px"
                                    width="100%"
                                />
                            </div>

                            {/* Show note when amount is less than paid amount */}
                            {this.state.unassignAmount > 0 && this.state.unassignAmount < this.state.unAssignInfo?.amountPaid && (
                                <div className="mt-2 p-2 bg-yellow-50 border-1 border-yellow-200 border-round">
                                    <p className="text-sm text-yellow-800 mb-1" style={{ fontFamily: 'InterMedium', fontWeight: 500, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                                        <i className="pi pi-info-circle mr-2"></i>
                                        <strong>Note:</strong> Remaining ₹{(this.state.unAssignInfo?.amountPaid - this.state.unassignAmount).toFixed(2)} amount will be considered as closing Fee Type amount.
                                    </p>
                                    <p className="text-sm text-yellow-700" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                                        ₹{this.state.unassignAmount} amount will be {this.state.unassignOption === 'refund' ? 'refunded' : 'moved to advance'}.
                                    </p>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Installment list for Adjust option */}
                    {this.state.unassignOption === 'adjust' && (
                        <div className="mb-4">
                            <label className='label mb-2' style={{ fontFamily: 'InterSemiBold', fontWeight: 500, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                                Distribute Amount to Fee Installments<span className='ma-required'>*</span>
                                <span className="text-sm text-500 ml-2" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '12px', lineHeight: '18px', letterSpacing: '0.4px', color: '#667A85' }}>
                                    (Total Max: ₹{this.state.unAssignInfo?.amountPaid})
                                </span>
                            </label>

                            {this.state.isLoadingInstallments ? (
                                <div className="text-center py-4">
                                    <LoadingComponent />
                                    <p style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>Loading fee installments...</p>
                                </div>
                            ) : this.state.feeInstallments.length > 0 ? (
                                <div className="mt-2">
                                    <DataTable
                                        value={this.state.feeInstallments}
                                        responsiveLayout="scroll"
                                        className="dataTableValuesText"
                                        showGridlines
                                        size="small"
                                    >
                                        <Column
                                            header='Sl.No'
                                            alignHeader={'center'}
                                            bodyClassName='text-center'
                                            style={{ width: '8%' }}
                                            body={(rowData, { rowIndex }) => {
                                                return (<span>{rowIndex + 1}</span>)
                                            }}
                                        />

                                        <Column filterField="feeType" field="feeType" sortable bodyClassName='text-center' header="Fee Type" alignHeader={"center"} />
                                        <Column filterField="feeTermName" sortable bodyClassName='text-center' header="Fee Term Name" alignHeader={"center"} body={(rowData, index) => {
                                            return (
                                                <p>{`Installment ${rowData?.term}`}</p>
                                            )
                                        }} />
                                        <Column filterField="termWiseActualValue" field="termWiseActualValue" sortable bodyClassName='text-center' header="Term wise Actual Fee" alignHeader={"center"}
                                            body={(rowData, { rowIndex }) => {
                                                return <div className="flex justify-content-center">{` ${Math.round((rowData?.termWiseActualValue) * 100) / 100}`}</div>;
                                            }} />
                                        <Column filterField="amountPaid" field="amountPaid" sortable bodyClassName='text-center' header="Paid Fee" alignHeader={"center"} />
                                        <Column filterField="totalDue" field="" sortable bodyClassName='text-center' header="Total Due" alignHeader={"center"} body={(rowData, index) => {
                                            let dueAmount = (Number(rowData?.dueAmount || 0))
                                            let conAmt = Number(rowData?.currentConAmt) || 0
                                            let finalDue = Number(dueAmount - conAmt).toFixed(2)
                                            return (
                                                <p>{finalDue}</p>
                                            )
                                        }} />
                                        <Column bodyClassName='text-center' header="Amount Paying" body={(rowData, index) => {
                                            let dueAmount = (Number(rowData?.dueAmount || 0))
                                            let conAmt = Number(rowData?.currentConAmt) || 0
                                            let finalDue = Number(dueAmount - conAmt)
                                            let isDisabled = finalDue <= 0

                                            return (
                                                <>
                                                    <ClassetInputText
                                                        className="text-xl hide-number-spinners"
                                                        type="text"
                                                        height="48px"
                                                        width="216px"
                                                        placeholder={'Enter Value'}
                                                        value={this.state.installmentAmounts.find(item => item._id === rowData?._id)?.requestedAmount || ''}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (value === '' || value.match(/^\d*\.?\d{0,2}$/)) {
                                                                this.handleInstallmentAmountChange(rowData, parseFloat(value) || 0, finalDue);
                                                            }
                                                        }}
                                                        onWheel={(e) => e.target.blur()}
                                                    />
                                                </>
                                            )
                                        }} />
                                    </DataTable>

                                    {/* Show note when some amount is allocated */}
                                    {(() => {
                                        const totalAssignedAmount = this.state.installmentAmounts.reduce((sum, item) => sum + (item.requestedAmount || 0), 0);
                                        const totalPaidAmount = this.state.unAssignInfo?.amountPaid || 0;
                                        const closingFeeAmount = totalPaidAmount - totalAssignedAmount;

                                        return totalAssignedAmount > 0 && (
                                            <div className="mt-2 p-2 bg-yellow-50 border-1 border-yellow-200 border-round">
                                                <p className="text-sm text-yellow-800 mb-1" style={{ fontFamily: 'InterMedium', fontWeight: 500, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                                                    <i className="pi pi-info-circle mr-2"></i>
                                                    <strong>Note:</strong> Total Paid is ₹{totalPaidAmount.toFixed(2)}
                                                </p>
                                                <p className="text-sm text-yellow-700" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                                                    ₹{closingFeeAmount.toFixed(2)} is the closing fee for {this.state.unAssignInfo?.feeType}
                                                </p>
                                                <p className="text-sm text-yellow-700" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                                                    ₹{totalAssignedAmount.toFixed(2)} will be adjusted for remaining fee types
                                                </p>
                                            </div>
                                        );
                                    })()}
                                </div>
                            ) : (
                                <div className="text-center py-4 text-500">
                                    <p style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px', color: '#667A85' }}>No fee installments available for adjustment</p>
                                </div>
                            )}
                        </div>
                    )}                    {/* Remarks field - always visible */}
                    <div className="mb-2">
                        <label className='label mb-2' style={{ fontFamily: 'InterSemiBold', fontWeight: 500, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>Remarks<span className='ma-required'>*</span></label>
                        <div className="mt-2">
                            <ClassetTextArea
                                className=""
                                height="48px"
                                width="100%"
                                placeholder="Enter Remarks"
                                value={this.state.remarks}
                                onChange={(e) => this.setState({ remarks: e.target.value })}
                            />
                        </div>
                    </div>
                </Dialog>

                {/* Parent Details Dialog for Refund */}
                <Dialog
                    visible={this.state.showParentDetailsDialog}
                    style={{ width: "400px", height: '80vh', minHeight: '600px' }}
                    draggable={false}
                    onHide={this.onHandleParentDetailsClose}
                    closable={false}
                    header={() => {
                        return (
                            <div className='mt-2 mb-4'>
                                <h3 className="formhead text-center">Payment Details</h3>
                            </div>
                        )
                    }}
                >
                    <div style={{ height: 'calc(100% - 0px)', display: 'flex', flexDirection: 'column', position: 'relative' }}>
                        <div className="flex flex-column align-items-center flex-1" style={{ overflowY: 'auto', paddingBottom: '20px' }}>
                            <div className="w-full flex justify-content-center mt-3">
                                <div style={{ width: '300px' }}>
                                    <label className="label mb-2">
                                        Payment Mode<span className="ma-required">*</span>
                                    </label>
                                    <div className="mt-2">
                                        <ClassetDropdown
                                            id="paymentType"
                                            className=""
                                            height="48px"
                                            width="100%"
                                            options={paymentModes?.filter(el =>
                                                el.label !== "Adjustment" &&
                                                el.label !== "Credit Card" &&
                                                el.label !== "Debit Card"
                                            )}
                                            value={this.state.paymentType}
                                            onChange={(e) => this.setState({ paymentType: e.value })}
                                            placeholder={
                                                <div>
                                                    <span className="">Select Payment Mode</span>
                                                </div>
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Online fields */}
                            {this.state.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' && (
                                <>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Account Holder Name<span className="ma-required">*</span>
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="accountHolderName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Account Holder Name"
                                                    value={this.state.accountHolderName}
                                                    onChange={(e) => this.setState({ accountHolderName: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Account Number<span className="ma-required">*</span>
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="accountNo"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Account Number"
                                                    value={this.state.accountNo}
                                                    onChange={(e) => this.setState({ accountNo: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                IFSC Code<span className="ma-required">*</span>
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="ifscCode"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter IFSC Code"
                                                    value={this.state.ifscCode}
                                                    onChange={(e) => this.setState({ ifscCode: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Bank Name & Branch<span className="ma-required">*</span>
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="bankName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Bank Name & Branch"
                                                    value={this.state.bankName}
                                                    onChange={(e) => this.setState({ bankName: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* QR Code fields */}
                            {this.state.paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489' && (
                                <div className="w-full flex justify-content-center mt-3">
                                    <div style={{ width: '300px' }}>
                                        <label className="label mb-2">
                                            UPI ID<span className="ma-required">*</span>
                                        </label>
                                        <div className="mt-2">
                                            <ClassetInputText
                                                id="upiId"
                                                height="48px"
                                                width="100%"
                                                placeholder="Enter UPI ID"
                                                value={this.state.upiId}
                                                onChange={(e) => this.setState({ upiId: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Cheque fields */}
                            {this.state.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' && (
                                <>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Cheque Issued To
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="chequeIssuedTo"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Cheque Issued To"
                                                    value={this.state.chequeIssuedTo}
                                                    onChange={(e) => this.setState({ chequeIssuedTo: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Cheque Number
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="chequeNo"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Cheque Number"
                                                    value={this.state.chequeNo}
                                                    onChange={(e) => this.setState({ chequeNo: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Cheque Date
                                            </label>
                                            <div className="mt-2">
                                                <ClassetCalendar
                                                    className=""
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Select Cheque Date"
                                                    calendarMode="single"
                                                    value={this.state.chequeDate}
                                                    onChange={(e) => this.setState({ chequeDate: e.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Bank Name
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="bankName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Bank Name"
                                                    value={this.state.bankName}
                                                    onChange={(e) => this.setState({ bankName: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Bank Branch Name
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="bankBranchName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Bank Branch Name"
                                                    value={this.state.bankBranchName}
                                                    onChange={(e) => this.setState({ bankBranchName: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* DD fields */}
                            {this.state.paymentType === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1' && (
                                <>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                DD Issued To
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="chequeIssuedTo"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter DD Issued To"
                                                    value={this.state.chequeIssuedTo}
                                                    onChange={(e) => this.setState({ chequeIssuedTo: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                DD Number
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="rrNumber"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter DD Number"
                                                    value={this.state.rrNumber}
                                                    onChange={(e) => this.setState({ rrNumber: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                DD Date
                                            </label>
                                            <div className="mt-2">
                                                <ClassetCalendar
                                                    className=""
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Select DD Date"
                                                    calendarMode="single"
                                                    value={this.state.chequeDate}
                                                    onChange={(e) => this.setState({ chequeDate: e.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Bank Name
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="bankName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Bank Name"
                                                    value={this.state.bankName}
                                                    onChange={(e) => this.setState({ bankName: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Bank Branch Name
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="bankBranchName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Bank Branch Name"
                                                    value={this.state.bankBranchName}
                                                    onChange={(e) => this.setState({ bankBranchName: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* Add extra bottom space */}
                            <div style={{ height: '30px' }}></div>
                        </div>

                        {/* Fixed buttons at bottom */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '15px'
                        }}>
                            <Button
                                label='Next'
                                className='submitButtonn button text-lg'
                                style={{ width: "150px" }}
                                onClick={this.handleUnassign}
                            />
                            <Button
                                style={{ width: "150px" }}
                                className='cancelButtonn'
                                onClick={this.onHandleParentDetailsClose}
                            >
                                <p className='cancelButtonnText'>Cancel</p>
                            </Button>
                        </div>
                    </div>
                </Dialog>

                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {this.state.isLoading && <LoadingComponent />}




            </div>
        )
    }
}

// Map Redux state to props to access student data
const mapStateToProps = (state) => ({
    students: state.studentData.students
});

export default connect(mapStateToProps)(UnAssignFee);

